import { Link } from 'react-router-dom';

export default function NeedToKnow() {
  const leftPoints = [
    'Our purpose-developed fabric meets all global safety compliance standards.',
    'Our canopies are completely waterproof and offer block-out grade UV protection.',
    'Fabric is treated for fade resistance and with mould inhibitors.',
    'Canopies are easily hosed down and lightly scrubbed to clean.',
  ];

  const rightPoints = [
    'Considered a semi-permanent solution, a custom canopy installation seldom requires planning permissions.',
    'Full coverage custom printed skins and branding options offer you further advantages.',
    'Choose from our wide range of brights, neutrals and earthy tones.',
  ];

  const swatches = [
    { hex: '#FFFFFF', border: true },
    { hex: '#9E9E9E', border: false },
    { hex: '#36454F', border: false },
    { hex: '#A89080', border: false },
    { hex: '#C49A5A', border: false },
    { hex: '#C6E832', border: false },
    { hex: '#A8B87A', border: false },
    { hex: '#2ECC40', border: false },
    { hex: '#1B5E3B', border: false },
    { hex: '#00D4D4', border: false },
    { hex: '#1A44CC', border: false },
    { hex: '#F5D000', border: false },
    { hex: '#F47B20', border: false },
    { hex: '#E8192C', border: false },
    { hex: '#800020', border: false },
    { hex: '#FF2D9B', border: false },
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-3xl md:text-4xl font-light text-center text-gray-800 mb-14">
          What you <strong className="font-bold">need to know</strong>
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-6">
          {/* Left column */}
          <ul className="space-y-5">
            {leftPoints.map((point) => (
              <li key={point} className="flex items-start gap-3">
                <span className="mt-1 w-4 h-4 flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-teal-500 text-base" />
                </span>
                <span className="text-sm text-gray-600 leading-relaxed">{point}</span>
              </li>
            ))}
          </ul>
          {/* Right column */}
          <ul className="space-y-5">
            {rightPoints.map((point) => (
              <li key={point} className="flex items-start gap-3">
                <span className="mt-1 w-4 h-4 flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-teal-500 text-base" />
                </span>
                <span className="text-sm text-gray-600 leading-relaxed">{point}</span>
              </li>
            ))}
            {/* Colour swatches */}
            <li className="flex items-center gap-2 pt-1 flex-wrap">
              {swatches.map((swatch, i) => (
                <span
                  key={`swatch-${swatch.hex}-${i}`}
                  className={`w-5 h-5 rounded-full flex-shrink-0 ${swatch.border ? 'border border-gray-300' : ''}`}
                  style={{ backgroundColor: swatch.hex }}
                />
              ))}
            </li>
          </ul>
        </div>
        <div className="mt-10 text-center">
          <Link
            to="/products/fabric-and-colours"
            className="inline-flex items-center gap-2 text-sm font-semibold text-teal-600 hover:text-teal-700 border border-teal-500 hover:border-teal-600 px-6 py-2.5 rounded-md transition-colors whitespace-nowrap cursor-pointer"
          >
            See More
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line" />
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}
